<template>
  <app-card>
    <div
      v-if="loading"
      class="d-flex align-items-center justify-content-center h-100"  
    >
      <div class="spinner-border" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    
    <div v-else>
      <div
        v-if="items.length"    
        :id="id"
        class="carousel slide carousel-dark"
        data-bs-interval="false"
      >
        <div class="carousel-inner">
          <div 
            v-for="(item, index) in items" 
            :key="index"
            class="carousel-item"
            :class="{ active: index === 0 }"
          > 
            <div class="featured-media rounded-75 overflow-hidden">
              <!-- YouTube -->
              <iframe 
                v-if="item.youtubeUrl"
                :src="item.youtubeUrl"
                class="w-100 h-100"
                allow="picture-in-picture;"
                :title="item.title" />            

              <!-- Image -->
              <img 
                v-else-if="item.imageUrl"
                :src="item.imageUrl" 
                class="w-100 h-100 object-fit-cover"                
                :alt="item.title"
              />

              <!-- Maps -->          
              <iframe
                v-else-if="item.coordinates && item.coordinates.length === 2"
                :src="`https://www.google.com/maps?q=${item.coordinates[0]},${item.coordinates[1]}&t=&z=15&ie=UTF8&iwloc=&output=embed`"
                class="w-100 h-100"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                :title="item.title"
              />
            </div>

            <!-- Body Section -->
            <h5 class="mt-3 mb-2 text-uppercase">{{ title }}</h5>

            <featured-card-body
              :title="item.title"
              :subtitle="item.subtitle"
              :description="item.description"
              :to="item.to"
              :href="item.href"
              :coordinates="item.coordinates"
            />
          </div>
        </div>

        <div v-if="items.length > 1" class="custom-carousel-controls position-absolute bottom-0 start-0 d-flex">
          <button class="carousel-control-custom bg-transparent border-0" type="button" :data-bs-target="`#${id}`" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button class="carousel-control-custom bg-transparent border-0" type="button" :data-bs-target="`#${id}`" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
      </div>

      <div v-else>        
        <p class="mt-3 mb-2 text-uppercase h5">{{ title }}</p>
        <p><b>No tenemos Información desponible por el momento.</b></p>        
      </div>
    </div>
  </app-card>
</template>

<script>
import AppCard from '../app/AppCard.vue';
import FeaturedCardBody from './FeaturedCardBody.vue';

export default {
  components: {
    AppCard,
    FeaturedCardBody,
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    loading: {
      type:Boolean,
      default: false
    },
  }
};
</script>

<style scoped>
.featured-media {
  height: 220px;
}
</style>